module.exports = __webpack_public_path__ + "static/media/Path2199.d9b10f89.svg";